import React, { useEffect } from 'react';
import { Accordion, Table } from 'semantic-ui-react';
import useTableSorter from '../hooks/useTableSorter.jsx';
import LogTableRow from './LogTableRow.jsx';
import LogMessageCellContent from './LogMessageCellContent.jsx';
import { statusFailed } from '../../util/packageUtils.js';

export default function LogTable({ rows }) {
  const sortable = useTableSorter(rows);

  useEffect(() => {
    sortable.onUpdate(rows);
  }, [rows]);

  return (
    <Accordion id={'package-log-table'}>
      <Table
        fixed
        sortable
      >
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell
              content={'Store'}
              sorted={sortable.getSorted('store_number')}
              width='one'
              onClick={() => sortable.onSort('store_number')}
            />
            <Table.HeaderCell
              content={'Host'}
              sorted={sortable.getSorted('host')}
              width='two'
              onClick={() => sortable.onSort('host')}
            />
            <Table.HeaderCell
              content={'Time'}
              sorted={sortable.getSorted('date')}
              width='two'
              onClick={() => sortable.onSort('date')}
            />
            <Table.HeaderCell
              content={'Status'}
              sorted={sortable.getSorted('readable_status')}
              width='four'
              onClick={() => sortable.onSort('readable_status')}
            />
            <Table.HeaderCell
              content={'Message'}
              width='two'
            />
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {sortable.sortedRows.map((row, idx) => (
            <LogTableRow
              key={idx}
              error={statusFailed(row.status)}
              message={row.message}
            >
              <Table.Cell
                singleLine
                content={row.store_number}
              />
              <Table.Cell
                singleLine
                content={row.host}
              />
              <Table.Cell
                singleLine
                content={row.date}
              />
              <Table.Cell content={row.readable_status} />
              <Table.Cell
                singleLine
                content={row.message ? <LogMessageCellContent /> : '—'}
                textAlign='center'
              />
            </LogTableRow>
          ))}
        </Table.Body>
      </Table>
    </Accordion>
  );
}
